const SHORT_OVERVIEW_COUNT = 5;

interface Overview {
  lat: number;
  lng: number;
}

export const getGoogleRouteSections = (sections: any[]) => sections.map(({ steps }) => {
  const shortOverview: Overview[] = [];
  const shift = Math.round(steps.length / SHORT_OVERVIEW_COUNT);

  for(let i = 0; i < steps.length; i += shift) {
    const item = steps[i];

    if (item) {
      shortOverview.push({
        lng: item.end_point.lng(),
        lat: item.end_point.lat(),
      });
    }
  }

  return {
    shortOverview
  };
});
